import { ChangeDetectorRef, Component, ElementRef, Inject, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AppService } from 'src/app/core/services/app.service';
import { CommanSubscribeService } from 'src/app/core/services/comman-subscribe.service';
import { StorageService } from 'src/app/core/services/storage.service';
import { UserService } from 'src/app/core/services/user.service';
import { environment } from 'src/environments/environment';
import { Subscription } from 'rxjs';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { CONST_AWS_API, API } from 'src/app/core/constants';
import { API as AWS_API } from 'aws-amplify';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
@Component({
  selector: 'app-tips-feedback-popup',
  templateUrl: './tips-feedback-popup.component.html',
  styleUrls: ['./tips-feedback-popup.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class TipsFeedbackPopupComponent implements OnInit {
  userInfoSubscription: Subscription;
  userInfo: any = {};
  screenMode: string = '';  //tips or polls
  activeBlock: string = '';
  streamInfo: any = null;
  audio_video: string = 'audio';
  video_polls_id: null;
  video_poll_title: null;

  // currency related
  searchCurrency: any = '';
  currencyJSON: any = [];
  getCurrency: any;
  currenciesList: any = [];
  currency: any;
  currentLocation: any;
  conversionRate: number = 1;

  // Tips related
  enteredTipAmount;
  tipsAmountsList: any = [];
  showPaymentScreen: boolean = false;

  // Polls related
  pollsQuestionsList: any = [];
  pollsQuestionIndex: number = 0;
  pollsProgressBar: number = 0;
  shareFeedbackContinueButton: boolean = false;
  pollsSelectedAnswers = [];
  pollsRawQuestionsList = [];
  pollsSubmittedResultData = [];
  formStatusSubscr: Subscription;
  selectedTransaction: any;
  currency_for_totAmt: number;
  amt_without_pf: number;
  crypto_amount: number;
  totalAmount: any;
  cryptoToken: any;
  cryptoSymbol: any;
  clientDetails: any;
  sliced_crypto_amount: number;
  dynamicSettingsData: any;
  @ViewChild('scrollElement') scrollElement!: ElementRef;
  constructor(
    private router: Router, private appService: AppService,
    private userService: UserService,
    private storageService: StorageService, private route: ActivatedRoute,
    private ngxLoader: NgxUiLoaderService,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private commonSubscribeService: CommanSubscribeService,
    private dialogRef: MatDialogRef<TipsFeedbackPopupComponent>,
    private toastr: ToastrService,
    private cdr: ChangeDetectorRef
  ) {
    this.commonSubscribeService.tipsDonationsPaymentSuccessful.subscribe(
      result => {
        if (result == 'success') {
          this.goToPollsScreen();
        }
      }
    )
  }

  ngOnInit() {
    if (this.data.settingsData) {
      this.dynamicSettingsData = this.data.settingsData;
      this.addStyle();
    }
    //console.log(this.data['selectedVideoId']);
    this.clientDetails = environment.clientDetails;
    this.cryptoToken = this.clientDetails.crypto_token;
    this.cryptoSymbol = this.clientDetails.crypto_symbol;

    if (this.data['selectedVideoId']) {
      this.audio_video = 'video';
    } else {
      this.audio_video = 'audio';
    }
    this.totalAmount = this.commonSubscribeService.getTotalAmount().subscribe(response => {
      this.currency_for_totAmt = response.currency;
      this.amt_without_pf = response.amt_without_pf;
      this.crypto_amount = this.commonSubscribeService.convertToCryptoAmount(this.amt_without_pf, this.rates[this.currency_for_totAmt])
      this.sliced_crypto_amount = Math.trunc(this.crypto_amount * Math.pow(10, 3)) / Math.pow(10, 3);
    })

    this.screenMode = (this.data && this.data.tipsOrPolls) ? this.data.tipsOrPolls : '';
    this.activeBlock = (this.screenMode == 'Tip' || this.screenMode == 'Donation') ? this.screenMode + 's' : null;
    this.currency = (this.data && this.data.currency) ? this.data.currency : null;

    this.userInfo = this.commonSubscribeService.userInfo;
    this.userInfoSubscription = this.commonSubscribeService.getUserInfo().subscribe(response => {
      this.userInfo = response;
    });

    this.formStatusSubscr = this.commonSubscribeService.getFormStatus().subscribe(response => {
      if (response) {
        this.closeDialog();
      }
    });

    this.commonSubscribeService.getCurrenciesJSON().subscribe(result => {
      Object.keys(result).forEach(element => {
        let value = element + ' - ' + result[element];
        this.currencyJSON.push({ 'currency': value });
        this.currenciesList.push(value);
      })
    });
    this.currentLocation = this.commonSubscribeService.locationInfo;
    this.getCurrency = this.storageService.getItem('currency');
    let locInfo = this.commonSubscribeService.locationInfo;
    this.currentLocation = locInfo && Object.keys(locInfo).length > 0 ? locInfo : this.storageService.getItem('current_location');
    if (!this.currentLocation || Object.keys(this.currentLocation).length == 0) {
      this.commonSubscribeService.getCurrentLocation((val: any, json: any) => {
        if (val == "fail") {
          this.currentLocation = {};
        } else {
          this.currentLocation = json;
          setTimeout(() => {
            this.setCurrency();
          }, 1000);
        }
      });
    }
    if (this.currentLocation && this.currentLocation.currency && (Object.keys(this.route.snapshot.queryParams).length == 0 || (Object.keys(this.route.snapshot.queryParams).length > 0 && !this.route.snapshot.queryParams.currency))) {
      setTimeout(() => {
        this.setCurrency();
      }, 1000);
    } else {
      setTimeout(() => {
        this.setCurrency();
      }, 1000);
    }
    this.getStreamInfo();
  }

  addStyle() {
    const progressBarColor = this.dynamicSettingsData?.font_tertiary_color;
    document.documentElement.style.setProperty('--progress-bar-color', progressBarColor)

  }

  calFee(response) {
    if (this.activeBlock == "Tips" || this.activeBlock == "Donations") {
      this.selectedTransaction = response.selectedTransaction;
      if (this.selectedTransaction == "wallet" || this.selectedTransaction == "crypto") {
        this.processingFee = 0;
        this.finalAmount = this.enteredTipAmount;
      } else if (this.selectedTransaction && this.selectedTransaction == "ott") {
        this.processingFee = 0;
        this.processingFee = (this.enteredTipAmount * (environment.processing_fee / 100)) + environment.fee_percentage;
        this.processingFee = Number(this.processingFee.toFixed(2));
        this.finalAmount = Number(this.enteredTipAmount) + this.processingFee;
      }
      let data = {
        "total_amount": this.finalAmount,
        "currency": this.currency,
        "processing_fee": this.processingFee ? this.processingFee : undefined,
        "amt_without_pf": Number(this.enteredTipAmount)
      }
      this.commonSubscribeService.totalAmountSubject.next(data);
    }
  }

  getPerformerDetails() {
    this.getCurrency = this.storageService.getItem('currency');
    let code = this.currentLocation && this.currentLocation.currency ? this.currentLocation.currency.code : '';
    let currentCode = code.includes('\"') ? JSON.parse(code) : code;
    let localCurrency = this.getCurrency && this.getCurrency.includes('\"') ? JSON.parse(this.getCurrency) : this.getCurrency
    let channel_name = this.router.url.split("/")[1];
    let data = {
      headers: {
        "Content-Type": "application/json",
        "x-api-key": environment.AWS_Cognito.X_Api_Key
      },
      response: true,
      body: {
        "channel_name": channel_name,
        "currency": this.currency,
        "user_id": this.userInfo.id
      }
    }
    this.ngxLoader.start();
    AWS_API.post(environment.AWS_Cognito.apiName, CONST_AWS_API.GET_PERFORMER_INFO, data).then(response => {
      if (response.data.statusCode === '200') {
        this.ngxLoader.stop();
        this.commonSubscribeService.sendPerfomerInfo(response);
        let amounts_json = null;
        if (response['data']['Data'] && response['data']['Data'][0] && response['data']['Data'][0]['performer_details'] && response['data']['Data'][0]['performer_details']['amounts_json']) {
          amounts_json = response['data']['Data'][0]['performer_details']['amounts_json'];
        }
        if (typeof amounts_json == 'string') {
          this.tipsAmountsList = JSON.parse(amounts_json);
        }
        if (this.tipsAmountsList.length > 0) {
          this.tipsAmountsList.forEach((tipElement, tipIndex) => {
            this.tipsAmountsList[tipIndex]['id'] = tipIndex;
            this.tipsAmountsList[tipIndex]['selected'] = false;
          });
        }
        this.getCurrencyRates();
      }
    })
      .catch(error => {
        console.log(error)
        this.ngxLoader.stop();
      });
  }

  //get event by slug
  getStreamInfo(from?) {
    // this.commonSubscribeService.getCurrentLocation((val: any, json: any) => {
    let data = {
      headers: {
        "Content-Type": "application/json",
        "x-api-key": environment.AWS_Cognito.X_Api_Key,
        "Authorization": `Bearer ${this.userInfo.access_token}`,
      },
      response: true,
      body: {
        "slug": (this.data && this.data.slug) ? this.data.slug : null,
        "userid": (this.data && this.data.id) ? this.data.id : null,
        "offset": new Date().getTimezoneOffset(),
        "currency": this.currency,
        "timezone": (this.data && this.data.timezone) ? this.data.timezone : null,
      }
    }
    AWS_API.post(environment.AWS_Cognito.apiName, CONST_AWS_API.GET_EVENT_BY_SLUG, data).then(response => {
      if (response.data.statusCode === '200') {
        this.streamInfo = response['data']['Data']['stream_info'];

        if (this.audio_video == 'audio') {
          this.streamInfo.tip_donation = 1;
          this.streamInfo.media_type = 'audio';
          this.commonSubscribeService.sendSlugData(this.streamInfo);
          let rawData = (response['data']['Data']['stream_info'] && response['data']['Data']['stream_info']['polls'] && response['data']['Data']['stream_info']['polls'].length > 0) ? response['data']['Data']['stream_info']['polls'] : []; // used while submitting the polls
          this.pollsRawQuestionsList = rawData.map(x => Object.assign({}, x));  // Deep copy to store raw data unchanged
          this.pollsQuestionsList = (this.streamInfo && this.streamInfo['polls'] && this.streamInfo['polls'].length > 0) ? this.streamInfo['polls'] : [];
          // Set id and all option select values, expanded as false
          if (this.pollsQuestionsList.length > 0) {
            this.pollsQuestionsList.forEach((question, questionIndex) => {
              question.options.forEach((option, optionIndex) => {
                this.pollsQuestionsList[questionIndex]['id'] = questionIndex;
                //this.pollsQuestionsList[questionIndex]['expanded'] = false;
                this.pollsQuestionsList[questionIndex]['options'][optionIndex] = {
                  option: this.pollsQuestionsList[questionIndex]['options'][optionIndex],
                  selected: false
                }
              });
            });
          }
          this.pollsProgressBar = this.pollsProgressBar = ((this.pollsQuestionIndex + 1) / (this.pollsQuestionsList.length)) * 100;
          this.getPerformerDetails();
        }
        if (this.audio_video == 'video') {
          response['data']['Data']['subEvents'].forEach((subEventElement, index) => {
            if (subEventElement.stream_info.id == this.data['selectedVideoId']) {
              this.video_polls_id = subEventElement.stream_info.poll_id;
              this.video_poll_title = subEventElement.stream_info.poll_title;
              this.streamInfo.tip_donation = 1;
              subEventElement.stream_info.media_type = 'video';
              this.commonSubscribeService.sendSlugData(subEventElement.stream_info);
              let rawData = subEventElement.stream_info.polls;
              this.pollsRawQuestionsList = rawData.map(x => Object.assign({}, x));  // Deep copy to store raw data unchanged
              this.pollsQuestionsList = subEventElement.stream_info.polls;
              // Set id and all option select values, expanded as false
              if (this.pollsQuestionsList.length > 0) {
                this.pollsQuestionsList.forEach((question, questionIndex) => {
                  question.options.forEach((option, optionIndex) => {
                    this.pollsQuestionsList[questionIndex]['id'] = questionIndex;
                    //this.pollsQuestionsList[questionIndex]['expanded'] = false;
                    this.pollsQuestionsList[questionIndex]['options'][optionIndex] = {
                      option: this.pollsQuestionsList[questionIndex]['options'][optionIndex],
                      selected: false
                    }
                  });
                });
              }
              this.pollsProgressBar = this.pollsProgressBar = ((this.pollsQuestionIndex + 1) / (this.pollsQuestionsList.length)) * 100;
              this.getPerformerDetails();
            }
          });
        }
      }
    }).catch(error => {
      console.log(error)
    });
    // });
  }

  // Currency related methods start here
  clearSearch() {
    this.searchCurrency = '';
  }

  changeCurrency(event) {
    let getVal = event.split(' -');
    this.currency = getVal[0]; //event;
    this.storageService.setItem('currency', getVal[0]);
    this.commonSubscribeService.sendCurrencyInfo(getVal[0]);

    this.enteredTipAmount = null;
    this.tipsAmountsList.forEach((element, index) => {
      this.tipsAmountsList[index]['selected'] = false;
    });
    this.getStreamInfo();
    this.getCurrencyRates();
  }

  setCurrency() {
    let cur = Object.keys(this.route.snapshot.queryParams).length > 0 && this.route.snapshot.queryParams.currency ? this.route.snapshot.queryParams.currency : this.getCurrency;
    this.currenciesList.forEach(element => {
      let getVal = element.split(' -');
      let code = cur ? cur : this.currentLocation.currency && this.currentLocation.currency.code.includes('\"') ? JSON.parse(this.currentLocation.currency.code) : this.currentLocation.currency.code
      if (getVal[0] == code) {
        let splitCurrency = element.split(' -')[0];
        this.currency = splitCurrency; // element;
        this.storageService.setItem('currency', getVal[0]);
        this.commonSubscribeService.sendCurrencyInfo(getVal[0]);
      }
    });
  }

  rates;
  getCurrencyRates() {
    let data = {
      headers: {
        "Content-Type": "application/json",
        "x-api-key": environment.AWS_Cognito.X_Api_Key,
        "Authorization": `Bearer ${this.userInfo.access_token}`
      },
      response: true,
      body: {}
    }
    let url = CONST_AWS_API.GET_EXCHANGE_RATES + '/' + this.streamInfo.currency_type;
    this.ngxLoader.start();
    AWS_API.get(environment.AWS_Cognito.apiName, url, data).then(response => {
      if (response.data.statusCode === '200') {
        this.ngxLoader.stop();
        this.rates = response['data']['Data']['rates'];
        this.conversionRate = this.rates[this.currency];
      }
    }).catch(error => {
      console.log(error)
      this.ngxLoader.stop();
    });
  }
  // Currency related methods end here

  // Tips related methods start here

  amountChange(value) {
    this.conversionRate = Number((this.conversionRate).toFixed(2));
    if (value != "" && Number(value) < Number(this.conversionRate)) {
      this.enteredTipAmount = "";
      let data = {
        "price": this.conversionRate,
        "currency": this.currency
      }
      this.commonSubscribeService.getCurPrice(data, result => {
        this.toastr.error('Minimum required amount is ' + result);
      });
    }
  }
  onSelectTipAmount(amount) {
    this.enteredTipAmount = null;
    if (!amount.selected) {
      this.tipsAmountsList.forEach((element, index) => {
        if (amount.id === element.id) {
          this.tipsAmountsList[index]['selected'] = true;
          this.enteredTipAmount = (element.value * this.conversionRate).toFixed(2);
        } else {
          this.tipsAmountsList[index]['selected'] = false;
        }
      });
    } else {
      this.tipsAmountsList.forEach((element, index) => {
        this.tipsAmountsList[index]['selected'] = false;
        this.enteredTipAmount = null;
      });
    }
  };

  tipAmountEntered(e) {
    this.tipsAmountsList.forEach((element, index) => {
      this.tipsAmountsList[index]['selected'] = false;
    });
  }

  goToPollsScreen() {
    //!this.enteredTipAmount && 
    if (this.pollsQuestionsList && this.pollsQuestionsList.length > 0) {
      this.screenMode = 'Poll';
    } else {
      // if(!this.enteredTipAmount){
      //   this.dialogRef.close();
      // }
      this.closeDialog();
    }
    this.pollsSelectedAnswers = [];
  }

  closeDialog() {
    const userId = this.userInfo?.user_first_name + ' ' + this.userInfo?.user_last_name;
    const albumId = this.commonSubscribeService.extractIdFromUrl(this.router.url);
    (window as any).umami?.track(`Album ${albumId} tips closed - ${userId}`)
    const u_payload = {
      actionType: "network",
      metaData: {
        title: `Album ${albumId} tips closed`,
        timeStamp: new Date().toISOString()
      },
      organizationId: this.streamInfo?.organization_id || null,
      clickAction: `album`
    }
    this.commonSubscribeService.sendTriggeredEvent(u_payload);

    this.dialogRef.close(true);
    this.commonSubscribeService.lastAudioEndedSubject.next(null);
  }

  processingFee = 0;
  finalAmount = 0;
  proceedToPaymentScreen() {
    if (this.enteredTipAmount && this.currency) {
      const userId = this.userInfo?.user_first_name + ' ' + this.userInfo?.user_last_name;
      const albumId = this.commonSubscribeService.extractIdFromUrl(this.router.url);
      (window as any).umami?.track(`Album ${albumId} tips continue clicked - ${userId}`)
      const u_payload = {
        actionType: "network",
        metaData: {
          title: `Album ${albumId} tips continue clicked`,
          timeStamp: new Date().toISOString()
        },
        organizationId: this.streamInfo?.organization_id || null,
        clickAction: `album`
      }
      this.commonSubscribeService.sendTriggeredEvent(u_payload);

      this.enteredTipAmount = Number(this.enteredTipAmount);
      this.processingFee = (this.enteredTipAmount * (environment.processing_fee / 100)) + environment.fee_percentage;
      //removing processing fee at start
      // this.finalAmount = this.enteredTipAmount + this.processingFee;
      this.finalAmount = this.enteredTipAmount;

      this.commonSubscribeService.formsValidationSubject.next(true);
      let data = {
        "total_amount": this.finalAmount,
        "currency": this.currency,
        "processing_fee": this.processingFee
      }
      this.commonSubscribeService.totalAmountSubject.next(data);
      this.showPaymentScreen = true;
    }
  }
  // Tips related methods end here

  // Polls related methods start here
  submittedPollsSuccessfully: boolean = false;
  goToNextQuestion() {
    this.submittedPollsSuccessfully = false;
    this.shareFeedbackContinueButton = false;
    this.pollsQuestionIndex = this.pollsQuestionIndex + 1;
    this.pollsProgressBar = ((this.pollsQuestionIndex + 1) / (this.pollsQuestionsList.length)) * 100;

    if (this.pollsQuestionIndex == this.pollsQuestionsList.length) {
      this.pollsQuestionsList.forEach((questionElement, questionIndex) => {
        questionElement.options.forEach((optionElement, optionIndex) => {
          if (optionElement.selected == true) {
            this.pollsSelectedAnswers.push(questionIndex + "_" + optionIndex);
          }
        });
      });

      this.pollsRawQuestionsList.forEach((question, questionIndex) => {
        question.options.forEach((option, optionIndex) => {
          delete this.pollsRawQuestionsList[questionIndex]['options'][optionIndex]['selected'];
          //console.log(this.pollsRawQuestionsList[questionIndex]['options'][optionIndex])
        });
      });

      let data = {
        headers: {
          "Content-Type": "application/json",
          "x-api-key": environment.AWS_Cognito.X_Api_Key,
          "Authorization": `Bearer ${this.userInfo.access_token}`,
        },
        response: true,
        body: {
          "poll_id": (this.audio_video == 'video') ? this.video_polls_id : this.streamInfo.poll_id,
          "user_id": Number(this.userInfo.id),
          "event_id": this.streamInfo.id,//16369, // Has to be changed for videos
          "stream_id": this.streamInfo.id,
          "options": this.pollsSelectedAnswers,
          "organization_id": this.streamInfo.organization_id,
          "channel_id": this.streamInfo.channel_id,
          "polls": this.pollsRawQuestionsList,
          "title": (this.audio_video == 'video') ? this.video_poll_title : this.streamInfo.poll_title,
        }
      }
      //console.log(data)
      this.pollsSubmittedResultData = [];  // TO avoid loading thanks for participation before loading questions
      this.ngxLoader.start();
      AWS_API.post(environment.AWS_Cognito.apiName, CONST_AWS_API.SUBMIT_POLLS, data).then(response => {
        if (response.data.statusCode === '200') {
          this.pollsSelectedAnswers = [];
          this.pollsSubmittedResultData = (response.data.poll && response.data.poll.length > 0) ? response.data.poll : [];

          this.pollsSubmittedResultData.forEach((element, index) => {
            this.pollsSubmittedResultData[index]['id'] = index;
            if (index == 0) {
              this.pollsSubmittedResultData[index]['expanded'] = true;
            } else {
              this.pollsSubmittedResultData[index]['expanded'] = false;
            }
          });

          if (this.pollsSubmittedResultData[0]['results'].length > 0) {
            this.pollsSubmittedResultData[0]['results'].forEach((percentElement, index) => {
              this.pollsSubmittedResultData[0]['results'][index] = Number(this.pollsSubmittedResultData[0]['results'][index]);
            });
          }
          this.ngxLoader.stop();
          this.submittedPollsSuccessfully = true;
          //console.log("SUBMIT DATa",this.pollsSubmittedResultData)
        } else if (response.data.statusCode === '204') {
          this.toastr.success("Poll already submitted")
          this.closeDialog();
          this.ngxLoader.stop();
          this.submittedPollsSuccessfully = true;
        }
      }).catch(error => {
        this.ngxLoader.stop();
        console.log(error)
      });
    }
  }

  expandQuestion(question) {
    if (question.expanded == false) {
      this.pollsSubmittedResultData.forEach((element, index) => {
        if (question.id == element.id) {
          this.pollsSubmittedResultData[index]['expanded'] = true;
        } else {
          this.pollsSubmittedResultData[index]['expanded'] = false;
        }
      });
    } else {
      this.pollsSubmittedResultData.forEach((element, index) => {
        this.pollsSubmittedResultData[index]['expanded'] = false;
      });
    }
  }

  selectPollsOption(i, option) {
    this.shareFeedbackContinueButton = false;
    if (!option.selected) {
      this.pollsQuestionsList[i].options.forEach((element, index) => {
        if (element.option == option.option) {
          this.pollsQuestionsList[i].options[index]['selected'] = true;
        } else {
          this.pollsQuestionsList[i].options[index]['selected'] = false;
        }
      });
    } else {
      this.pollsQuestionsList[i].options.forEach((element, index) => {
        this.pollsQuestionsList[i].options[index]['selected'] = false;
      });
    }
    this.pollsQuestionsList[i].options.forEach(element => {
      if (element.selected) {
        this.shareFeedbackContinueButton = true;
      }
    });
  }
  // Polls related methods end here

  ngAfterViewInit() {
    this.cdr.detectChanges();
  }

  ngOnDestroy() {
    if (this.userInfoSubscription)
      this.userInfoSubscription.unsubscribe();
    if (this.formStatusSubscr)
      this.formStatusSubscr.unsubscribe();
    if (this.totalAmount)
      this.totalAmount.unsubscribe();
    this.appService.videoEnded.next(null);
    this.video_polls_id = null;
    this.video_poll_title = null;
  }

}
